<template>
  <div v-if="moments.count && moments.count > 0">
    <router-link
      :to="{
        name: 'MainRegionPage',
        query: {
          type: 'moment',
          artist: artistSlug
        }
      }"
    >
      <div
        v-if="moments.moments && moments.moments[0]?.medias"
        class="moment-container relative h-[152px]"
      >
        <picture>
          <img
            class="moment-img"
            :src="moments.moments[0]?.medias[0].image"
            :alt="`${artistSlug} moment image`"
          />
        </picture>
        <img
          class="moments-logo"
          src="@/assets/images/ic-moments-white.svg"
          alt="Moments logo"
        />
      </div>
    </router-link>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useMoment } from "@/composables/useMoment";
import moment from "moment";

const {
  moments,
  currentPage,
  nextPage,
  artistsTags,
  venuesTags,
  changePage,
  getArtistsTrendingMoment,
  getMoments
} = useMoment();
const props = defineProps({
  artistSlug: {
    type: [Object, String],
    default: undefined
  }
});
const route = useRoute();
const router = useRouter();
onMounted(() => {
  getMoments({ tag_slug: props.artistSlug });
});
</script>

<style lang="scss" scoped>
.moment-container {
  width: 152px;
  height: 152px;
  position: relative;
  //   opacity: 0.8;
  &:after {
    content: "";
    z-index: 2;
    width: 100%;
    height: 152px;
    border-radius: 5px;
    position: absolute;
    top: 0;
    opacity: 0.8;
    background-color: $scrollBackgroundColor-80;
    @media screen and (min-width: $screen-md) {
      height: 152px;
    }
  }
  &:hover {
    transform: scale(1.05);
  }
}
.moment-img {
  width: 152px;
  height: 152px;
  border-radius: 5px;
  object-fit: cover;
  position: relative;
}
.moments-logo {
  width: 27px;
  height: 28px;
  position: absolute;
  top: 80%;
  bottom: 0;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  z-index: 3;
}
</style>
